/**
 * @generated SignedSource<<2aac5157288b209612c2559154239490>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FileType = "DOC" | "DOCX" | "PDF" | "PPT" | "PPTX" | "XLS" | "XLSX";
import { FragmentRefs } from "relay-runtime";
export type AttachedContent_files$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string | null;
  readonly type: FileType | null;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedFileItem_file">;
  readonly " $fragmentType": "AttachedContent_files";
}>;
export type AttachedContent_files$key = ReadonlyArray<{
  readonly " $data"?: AttachedContent_files$data;
  readonly " $fragmentSpreads": FragmentRefs<"AttachedContent_files">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "AttachedContent_files",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LinkedFileItem_file"
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "ba3f5e3e0ae1956f0525d3be196b1c79";

export default node;
